import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";
const qs = require("qs");

export async function fetchPodcast(params) {
  return await request({
    url: ENDPOINT.PODCAST,
    method: "get",
    params,
  });
}

export async function fetchPodcastById(id) {
  return await request({
    url: `${ENDPOINT.PODCAST}/${id}`,
    method: "get",
  });
}

export async function createPodcast(data) {
  return await request({
    url: ENDPOINT.PODCAST,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function updatePodcast(id, data) {
  return await request({
    url: `${ENDPOINT.PODCAST}/${id}`,
    method: "put",
    data: qs.stringify(data),
  });
}

export async function deletePodcast(id) {
  return await request({
    url: `${ENDPOINT.PODCAST}/${id}`,
    method: "delete",
  });
}
